export const ATTRIBUTE_MODEL = {
    //"scaffold_block_smi": null,
    //"scaffold_block_r": null,
    "scaffold": null,
    "capping": false,
    "capping_scaffold": null,
    // "capping_smi": null,
    // "capping_r": null,
    "blocks_file": null,
    "blocks_file_type": "Blocksfiles",
    "learning_rate": "5e-4",
    "mbsize": 16,
    "opt_beta": 0.9,
    "opt_beta2": 0.999,
    "opt_epsilon": "1e-8",
    "nemb": 256,
    "min_blocks": 2,
    "max_blocks": 5,
    "num_iterations": 1000,
    "num_conv_steps": 10,
    "log_reg_c": "2.5e-5",
    "reward_exp": 1,
    "reward_norm": 1,
    "sample_prob": 1,
    "R_min": 0.1,
    "leaf_coef": 10,
    "clip_grad": 0,
    "clip_loss": 0,
    "replay_mode": "online",
    "bootstrap_tau": 0,
    "weight_decay": 0,
    "random_action_prob": 0.05,
    //"repr_type": "block_graph",
    "model_version": "v4",
    //"run": 0,
    //"floatX": "float64",
    //"include_nblocks": false,
    //"balanced_loss": false,
    //"do_wrong_thing": false,
    "device": "cuda",
    //"batchwise_reward": false,
    "reward_mode": "exp_scaling",
    //"sample_unique_only": null,
    "unique_samples": true,
    //"multithreading": null,
    //"no_multithreading": null,
    //"system": "brainiac",
    "assign_partial_rewards": false,
    "save_path": "./results/",
    //"proxy_path": "./data/pretrained_proxy",
    //"pretrained_param_file": null,
    //"temp_dir": "./data/",
    //"print_array_length": false,
    //"progress": "yes",
    //"verbose": false,
    "SMARTS_file": null,
    //"unique_refmols": null,
    "include_similarity_to_ref": false,
    "ref_compounds": null,
    //"toggle_unique_filter": false,
    "include_ringrarity": false,
    //"exclude_ringrarity": null,
    "microsomal_limit": 1000,
    "microsomal_model_type": "sprime",
    "mdck_limit": -0.31,
    "mdck_model_type": "sprime",
    "include_clogD": false,
    "clogD_l_limit": 0.0,
    "clogD_u_limit": 5.0,
    //"w_filters_file": null,
    "include_pKa": false,
    "pKa_llimit": 5.0,
    "pKa_ulimit": 8.0,
    "include_potency": false,
    "potency_model_script": "None",
    "docking_proxy_filter": false,
    "docking_model": "None",
    "docking_model_type": "classifier",
    "docking_reward_utility_function": "sigmoid",
    "docking_reward_sigmoid_params": [1,0,0,-1],
    "include_medchemrules": false,
    "medchemrules_thres": 300,
    //"debug_proxy": false,
    "limit_chiral_centers": false,
    "w_nchiral_0": 0,
    "w_nchiral_1": 2,
    "limit_ring_size": false,
    "w_lrsz_0": 3,
    "w_lrsz_1": 7,
    "limit_number_of_aromatic_rings": false,
    "w_arrings_0": 1,
    "w_arrings_1": 5,
    "limit_number_of_rings": false,
    "w_nrings_0": 4,
    "w_nrings_1": 10,
    "w_amw_0": 300,
    "w_amw_1": 1000,
    "limit_rotatable_bonds": false,
    "w_rotbond_0": 1,
    "w_rotbond_1": 10,
    "limit_halogens": false,
    "w_halogen_0": 0,
    "w_halogen_1": 3,
    "Limit_OH_NH": false,
    "w_ro5_ohnh_0": 1,
    "w_ro5_ohnh_1": 5,
    "limit_polar_surface_area": false,
    "w_nvrtspsa_0": 0,
    "w_nvrtspsa_1": 150,
    "limit_H_bond_donors": false,
    "w_hdons_0": 0,
    "w_hdons_1": 5,
    "limit_H_bond_acceptors": false,
    "w_hacts_0": 0,
    "w_hacts_1": 7,
    "include_tsubmatching": false
};
